import type { ComponentEvent } from '@guardian/ophan-tracker-js';
import { getOphan } from '../../client/ophan/ophan';
import { isServer } from '../../lib/isServer';
import type { RenderingTarget } from '../../types/renderingTarget';
import type { CurrentSignInGateABTest } from './types';

export type ComponentEventParams = {
	componentType: string;
	componentId?: string;
	abTestName: string;
	abTestVariant: string;
	viewId?: string;
	browserId?: string;
};

// ophan helper methods
export const submitComponentEventTracking = async (
	componentEvent: ComponentEvent,
	renderingTarget: RenderingTarget,
) => {
	if (isServer) return;

	const ophan = await getOphan(renderingTarget);
	ophan.record({ componentEvent });
};

export const submitViewEventTracking = (
	componentEvent: Omit<ComponentEvent, 'action'>,
	renderingTarget: RenderingTarget,
) =>
	void submitComponentEventTracking(
		{
			...componentEvent,
			action: 'VIEW',
		},
		renderingTarget,
	);

const submitClickEventTracking = (
	componentEvent: Omit<ComponentEvent, 'action'>,
	renderingTarget: RenderingTarget,
) =>
	void submitComponentEventTracking(
		{
			...componentEvent,
			action: 'CLICK',
		},
		renderingTarget,
	);

export const withComponentId = (id?: string): ComponentEvent['component'] => ({
	componentType: 'SIGN_IN_GATE',
	id,
});

export const trackLink = (
	componentId: string,
	value: string,
	renderingTarget: RenderingTarget,
	abTest?: CurrentSignInGateABTest,
	labels?: string[],
): void => {
	const component = { ...withComponentId(componentId), labels };

	submitClickEventTracking(
		{
			component,
			abTest,
			value,
		},
		renderingTarget,
	);
};
